<template>
  <div class="footer" :class="{'space-below': isComic, 'show-social': showSocial}">
    <div v-if="showSocial">
      <small>&copy; {{ year }}</small>
    </div>
    <div>
      <p class="footer__message" v-html="footerHTML"></p>
      <div class="footer__version" style="opacity: 0.5" v-if="isAdmin">. Version {{version}}</div>
    </div>
    <div v-if="showSocial">
      <div class="footer__follow">
        <small>Follow @jandcomic</small>
        <div class="footer__links">
          <a
            v-for="link in links"
            :key="link.name"
            class="footer__icon"
            :href="link.url"
          >
            <social-icon :name="link.name.toLowerCase()" />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SocialIcon from '@/components/SocialIcon.vue';

export default {
  name: 'Footer',
  components: {
    SocialIcon,
  },
  data() {
    return {
      version: '1.2.4',
    };
  },
  computed: {
    ...mapGetters(['getSite', 'getMode']),
    isComic() {
      const comicRoutes = ['Home', 'Comic'];
      return comicRoutes.includes(this.$route.name);
    },
    footerHTML() {
      return this.getSite && this.getSite.footerHTML;
    },
    showSocial() {
      return this.getSite && this.getSite.options && this.getSite.options.showSocial;
    },
    links() {
      return this.getSite && this.getSite.contactLinks.filter(({ type }) => (type === 'href'));
    },
    year() {
      return new Date().getFullYear();
    },
    isAdmin() {
      return this.getMode === 'admin';
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.footer {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  &.show-social {
    justify-content: space-between;
  }
  > div {
    min-width: 100px;
  }
  @media all and (max-width: 1000px) {
    display: block;
    > div {
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      margin: 20px 0;
    }
  }
  @media all and (max-width: 700px) {
    &.space-below {
      margin-bottom: 100px;
    }
  }
  &__message, &__version {
    max-width: 280px;
    line-height: 1.2;
    margin: 0;
    text-align: center;
    font-size: var(--font-small);
  }
  &__version {
    opacity: 0.5;
    margin-top: 5px;
  }
  &__follow {
    small {
      display: none;
      @media all and (max-width: 1000px) {
        display: block;
      }
    }
  }
  &__links {
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
  }
  &__icon {
    @media all and (min-width: 1000px) {
      margin: 5px;
    }
    @media all and (max-width: 1000px) {
      margin: 10px;
    }
  }
}
</style>
